module.exports = __webpack_public_path__ + "assets/media/navigations-app-store.630af9b9.svg";